import { format, parseISO } from 'date-fns';

// Chat message timestamps (WIPE-981). Agents copy these into their notes and use
// them to judge how long a request took, so they render in the reader's local
// zone from the server-supplied instant.

// Clock time shown beside each message, e.g. "2:41 PM".
export function formatMessageTime(at: string): string {
  const date = parseISO(at);
  if (Number.isNaN(date.getTime())) return '';
  return format(date, 'h:mm a');
}

// Full instant for the hover title and the downloaded transcript, where there is
// no surrounding context to say which day a bare clock time belongs to.
export function formatMessageTimestamp(at: string): string {
  const date = parseISO(at);
  if (Number.isNaN(date.getTime())) return '';
  return format(date, 'MMM d, yyyy h:mm:ss a');
}
